"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DropDownSelectableItem_1 = __importDefault(require("./DropDownSelectableItem"));
var DropDownSelectableList = /** @class */ (function (_super) {
    __extends(DropDownSelectableList, _super);
    function DropDownSelectableList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedItemId: null,
            default: true
        };
        _this.onClick = function (evt, item) {
            _this.setState(function () {
                return { selectedItemId: item.props.id, default: false };
            }, function () {
                _this.props.onSelect(item);
                if (_this.props.closeOnSelect) {
                    _this.props.onRequestClose && _this.props.onRequestClose();
                }
            });
        };
        return _this;
    }
    DropDownSelectableList.prototype.render = function () {
        var _this = this;
        var children = this.props.children;
        return children &&
            react_1.default.Children
                .toArray(children)
                .map(function (item, i) {
                return (react_1.default.createElement(DropDownSelectableItem_1.default, __assign({}, item.props, { id: i, selected: _this.state.default ? _this.props.defaultId === i : _this.state.selectedItemId === i, key: i, onClick: function (evt) { return _this.onClick(evt, item); } })));
            });
    };
    DropDownSelectableList.defaultProps = {
        defaultId: 0,
        closeOnSelect: true
    };
    return DropDownSelectableList;
}(react_1.default.Component));
exports.default = DropDownSelectableList;
